export enum CrusherJawTypes {
  CJ211 = 'CJ211',
  CJ409 = 'CJ409',
  CJ411 = 'CJ411',
  CJ412 = 'CJ412',
  CJ613 = 'CJ613',
  CJ615 = 'CJ615',
  CJ815 = 'CJ815',
}

export interface CrusherJawCJInfoDataInterface {
  [model: string]: CrusherJawInterface;
}

export interface CrusherJawInterface {
  motorPower: number;
  maxFeed: number;
  feedOpenHeight: number;
  feedOpenWidth: number;
  lowerCSS: number;
  upperCSS: number;
  capacityConstant: number;
  capacityOffset: number;
}
